import PropTypes from 'prop-types';
export const ToolbarControlTypes = {
  BUTTON: 'BUTTON',
  SELECT: 'SELECT',
  DIVIDER: 'DIVIDER',
  MORE_MENU: 'MORE_MENU',
  ADVANCED_MENU: 'ADVANCED_MENU',
  INSERT_MENU: 'INSERT_MENU'
};
export const MenuTypes = [ToolbarControlTypes.ADVANCED_MENU, ToolbarControlTypes.INSERT_MENU, ToolbarControlTypes.MORE_MENU];
export const ToolbarControlMargins = {
  DEFAULT: 8,
  BUTTON: 2,
  ZERO: 0
};
export const controlPropType = PropTypes.shape({
  type: PropTypes.oneOf(Object.keys(ToolbarControlTypes)).isRequired,
  control: PropTypes.string
});
export const TOOLBAR_I18N_PREFIX = 'RichTextLib.toolbar';
export const toolbarI18nKey = suffix => `${TOOLBAR_I18N_PREFIX}.${suffix}`;
export const DEBOUNCE_TIMEOUT = 500;